export const locale = {
  lang: "fr",
  data: {
    mandatory: "Obligatoire",
    maintenance:
      "<p>Nous procédons présentement à des opérations de maintenance. Merci d'essayer de nouveau un peu plus tard.</p>",
    badBrowser:
      "<p>Ce site web n´est pas supporté par Internet Explorer. Vous pouvez utiliser Chrome, Edge ou un autre navigateur.</p>",
    error: {
      generalError: {
        title: "Une erreur est survenue",
        message:
          "L'application a rencontré un problème inattendu qui l'empêche de répondre à la requête.",
        backToHome: "Retour à la page d'accueil",
      },
      forbidden: {
        title: "Vous n'avez pas la permission de voir la ressource",
        message: "Le serveur comprend la requête mais refuse de l'autoriser.",
        backToHome: "Retour à la page d'accueil",
      },
      unauthorized: {
        title: "Vous n'êtes pas autorisé à voir cette ressource",
        message:
          "La requête n'a pas été effectuée car il manque des informations d'authentification valides pour la ressource visée.",
        backToHome: "Retour à la page d'accueil",
      },
      pageNotFound: {
        title: "Oops! Page Introuvable",
        message:
          "Désolé, mais la page que vous recherchez n'existe pas, a été supprimée, son nom a été modifié ou est temporairement indisponible.",
        backToHome: "Retour à la page d'accueil",
      },
      auth: {
        sessionFailure: {
          title: "Votre session a expiré",
          message:
            "Pour maintenir la sécurité, les sessions inactives expirent automatiquement. Le travail en cours a été sauvegardé. Cliquez sur Continuer à travailler pour vous reconnecter",
          safariHint:
            'Des problèmes avec Safari <img src="https://imgur.com/cBuAiAW.png" alt="Safari" width="30" height="30" /> ?',
          safariMacInstructions:
            'Pour vous connecter avec votre Mac, dans l’app Safari <img src="https://imgur.com/cBuAiAW.png" alt="Safari" width="30" height="30" />, choisissez <strong>Safari > Préférences</strong>, puis cliquez sur <strong>Confidentialité</strong> et désélectionnez <strong>« Empêcher le suivi sur plusieurs domaines »</strong>.',
          safariIosInstructions:
            'Pour vous connecter avec votre iPhone/iPad, dans l’app Safari <img src="https://imgur.com/cBuAiAW.png" alt="Safari" width="30" height="30" />, choisissez <strong>Safari</strong> dans la liste des <strong>Réglages</strong> du système, puis aller dans la section <strong>Confidentialité et sécurité</strong> et désactivez l’interrupteur <strong>« Empêcher le suivi sur plusieurs domaines »</strong>.',
          ok: "Continuer à travailler",
          cancel: "Quitter",
        },
        signInFailure: {
          title: "Échec d'authentification",
          message:
            "Une erreur est survenue lors de votre authentification.<br>{{errMsg}}",
          ok: "Ok",
        },
        no_authentication_service:
          "Aucun service d'authentification disponible. SVP contacter le support ODQ.",
        cannot_validate_user_permissions:
          "Impossible de valider les permissions de l'usager",
      },
      file: {
        title: "Fichier",
        message: "Une erreur s'est produite lors du téléchargement du fichier",
      },
    },
    boolean: {
      true: "Oui",
      false: "Non",
    },
    emptyStates: {
      companies: {
        tagline: "Aucune société disponible",
        hint: "",
      },
      activities: {
        tagline: "Aucune activité pour cette période de référence ",
      },
      inscription: {
        tagline: "Aucun formulaire d'inscription disponible",
      },
    },
    member: {
      firstName: "Prénom du membre de l´Ordre",
      lastName: "Nom",
      permitNumber: "Numéro de permis",
    },
    pdf: {
      isLoading: "Votre document est en cours de chargement...",
      unableToDownload:
        "Impossible de télécharger votre pdf. Veuillez réessayer plus tard...",
      printableVersion: "Version imprimable de votre {{product}}",
      getPrintableVersion: "Télécharger une version imprimable (PDF)",
    },
    attachment: {
      unableToUpload: "Impossible de téléverser le document",
      unableToDelete: "Impossible de supprimer le document",
    },
    navigation: {
      back: "Précédent",
      next: "Suivant",
      ok: "Valider",
      cancel: "Annuler",
      close: "Fermer",
      retry: "Réessayer",
      fill: "Remplir le formulaire",
    },
    warning: {
      fieldNotSet: "[Non définie]",
    },
    fileUpload: {
      message: {
        header: "Téléversement",
        succeed: "Votre téléversement a réussi",
        failed: "Votre téléversement a échoué",
      },
      dropFileHere: "Déposez votre fichier ici",
      chooseFile: "Parcourir...",
      uploadFile: "Téléverser le fichier",
      uploadAFile: "Téléverser un fichier",
      noFile: "Pas de fichier",
      emptyList: "Vous n'avez joint aucun document",
      fileDetails: {
        filename: "Nom de fichier",
        documentType: "Type du document",
        fileTitle: "Titre du fichier",
      },
      deleteDialog: {
        title: "Supprimer un document",
        message: "Voulez-vous vraiment supprimer le document ?",
      },
    },
    sessionTimeoutDialog: {
      title: "Votre session arrive bientôt à expiration",
      message: `Pour des raisons de sécurité, votre session expirera dans quelques minutes.
                Veuillez fermer cette fenêtre et sauvegarder vos changements.
                `,
      buttons: {
        closeDialog: "Fermer",
      },
    },
    technicalDifficultiesDialog: {
      title: "Erreur",
      message: `Une erreur est survenue pendant la sauvegarde des données. Svp veuillez réessayer.<br/><br/>
                Si le problème se reproduit alors veuillez arrêter la saisie et contacter notre billetterie par courriel
                 à <a href="mailto:billetterie@odq.qc.ca">billetterie@odq.qc.ca</a> en prenant soin de mettre votre nom et votre numéro de permis dans le courriel.
      `,
      buttons: {
        closeDialog: "Fermer",
      },
    },
    form: {
      submit: "Sauvegarder",
      accept: "Accepter",
      cancel: "Annuler",
      field: {
        endDate: "Date de fin",
        startDate: "Date de début",
      },
      type: {
        AnnualDeclaration: "Déclaration Annuelle",
        EndOfPractice: "Déclaration de fin d´exercice en société",
      },
      warning: "Attention",
      validateWithAcountant:
        "<span class='text-danger font-weight-bold'>VEUILLEZ VÉRIFIER</span> les informations de cette section avec votre représentant ou votre conseiller juridique.",
      changeDate: "Date du changement",
      save: "Sauvegarder",
      reset: "Réinitialiser",
      lastSave: "Dernière sauvegarde",
      completed: "Votre déclaration est complété",
      validation: {
        email: "Format de courriel incorrect",
        required: "Champ obligatoire",
        selectionRequired: "Choisissez un élément dans la liste",
        more_than_point_five: "La valeur doit être supérieure à 0.5",
        adressFormat: "Choisissez une adresse dans la liste",
        positive: "La valeur doit être supérieure ou égale à 0",
        fileMaxSize:
          "La taille maximale du fichier doit être inférieure ou égale à 250 Mb",
      },
      saveToast: {
        title: "Sauvegarde",
        message:
          "Les modifications sont en cours de sauvegarde, veuillez patienter",
      },
      initToast: {
        title: "Réinitialisation",
        message:
          "Le formulaire est en cours de réinitialisation, veuillez patienter",
      },
      previousStep: "Étape précédente",
      nextStep: "Prochaine étape",
      uploadDocument: "Téléverser des documents",
      annual: {
        declaration: {
          document: {
            Other: "Autre document",
            CertifiedCopyAmendingDeclarationWithNEQ:
              "Copie certifiée de toute déclaration modificative déposée au Registraire des entreprises du Québec [REQ]",
            CopyCertificateAmalgamationIssuedByREQ:
              "Copie du certificat de fusion délivré par le REQ",
            CopyDeclarationShortFormMergerFiledWithREQ:
              "Copie de la déclaration produite auprès du REQ pour déclarer la fusion simplifiée",
            CopyCertificateAmalgamationIssuedInnovationScienceAndEconomicDevelopmentCanada:
              "Copie du certificat de fusion délivré par Innovation, Sciences et Développement économique Canada",
            CopyAnyCertificateNameChangeIssuedByREQ:
              "Copie du certificat de modification du nom délivré par le REQ",
            DeclarationFiledWithREQAttestingNameChange:
              "Déclaration déposée au REQ qui atteste du changement de nom",
            CertificateNameChangeIssuedByCorporationsCanada:
              "Certificat de modification du nom délivré par Corporations Canada",
            OriginalFormAgreementBetweenDentistTransferringRecordsAndDentistReceivingTransferredRecords:
              "Original du formulaire Convention entre un dentiste cédant ses dossiers et Ie cessionnaire des dossiers",
            CompanyInformationStatementAtREQ: "État des renseignements (REQ)",
          },
          summaryDialog: {
            workingCopy: "Copie de travail",
            submittedCopy: "Version soumise à l´Ordre",
          },
          fileNumber: "Dossier",
          title: "Déclaration annuelle",
          summary: "Sommaire et Attestation ",
          attestation: "Attestation",
          summaryContent: {
            mandatedIdentification: {
              title: "Membre répondant ou représentant mandaté",
              filledBy: "Déclaration remplie par : ",
              name: "Nom et prénom",
              email: "Courriel",
              date: "Date",
              representative: "un représentant mandaté",
              respondent: "le membre répondant",
            },
            warning2:
              "<span class='importantText'>* Attention :</span><br><br>Un sommaire de votre déclaration annuelle sera bientôt disponible (en format PDF).<br><br>Au cours des prochaines semaines, vous recevrez un courriel vous invitant à vous rendre dans la section Société du portail de l’Ordre afin de consulter le sommaire de votre déclaration annuelle en format PDF. Vous pourrez alors l’imprimer pour vos dossiers.<br><br>Lorsque vous aurez cliqué sur ce bouton, il ne sera plus possible de revenir aux sections précédentes ni de modifier le formulaire.",
            operation: "Opération",
            section1: {
              area_2: {
                msgName: "Nom",
              },
              area_4: {
                member: "Membre",
              },
            },
            section3: {
              type: "Type",
            },
            section4: {
              shareholderOdqMember:
                "Actionnaire(s)/fiduciaire(s) – Membre(s) de l’Ordre",
            },
            section5: {
              members: "Membre(s) de l’Ordre",
              spouses: "Conjoint(e)/parent(s)",
              shareholders: "Actionnaire(s)",
              trustees: "Fiduciaire(s)",
              odqMemberTitle:
                "Actionnaire(s)/fiduciaire(s) - Membre(s) de l’Ordre",
              spouseReactiveTitle:
                "Actionnaire(s)/fiduciaire(s) - Conjoint(e)/parent(s)",
            },
            section6: {
              title: "Documents téléversés",
              noUploadDocument: "Aucun document téléversé.",
            },
          },
          uploadDocument:
            "<span class='font-weight-bold'>TÉLÉVERSEMENT DE DOCUMENT POUR VOTRE DÉCLARATION ANNUELLE</span>",
          tabLabel: {
            companyInformation: "Informations sur la société",
            membersVoting: `Membres <span class='tab-header-highlight-text'>AVEC DROIT DE VOTE</span>`,
            legalPersonVoting: "Personnes morales / fiducies <span class='tab-header-highlight-text'>AVEC DROIT DE VOTE</span>",
            naturalPersonNonVoting: "Personnes physiques <span class='tab-header-highlight-text'>SANS DROIT DE VOTE</span>",
            legalPersonNonVoting: "Personnes morales / fiducies <span class='tab-header-highlight-text'>SANS DROIT DE VOTE</span>",
          },
          summarySectionTitles: {
            companyInformation: "Informations sur la société",
            membersVoting: `Membres AVEC DROIT DE VOTE`,
            legalPersonVoting:
              `Personnes morales / fiducies AVEC DROIT DE VOTE`,
            naturalPersonNonVoting: `Personnes physiques SANS DROIT DE VOTE`,
            legalPersonNonVoting:
              `Personnes morales / fiducies SANS DROIT DE VOTE`,
          },
          directive: {
            title: "Directives",
            p1: "L’article 187.11 du Code des professions (L.R.Q., c. C-26) prévoit que le membre peut exercer ses activités professionnelles en société s’il fournit à l’Ordre des dentistes du Québec une déclaration à cet effet, conformément aux exigences prescrites au Règlement sur l’exercice de la profession de dentiste en société (ci-après appelé « Règlement »). L’article 4 du Règlement requiert que cette déclaration soit fournie à l’Ordre des dentistes du Québec (« l’Ordre ») préalablement à l’exercice en société.",
            p2: `L’article 6 du Règlement prévoit que la déclaration de mise à jour doit être fournie avant le 31 mars de chaque année. De plus, 
                  <span class="font-weight-bold">dès qu’une modification</span> survient dans les informations décrites <span class="font-weight-bold">dans cette déclaration 
                  et les mises à jour subséquentes</span>, l’Ordre doit en être informé <span class="font-weight-bold">SANS DÉLAI</span> par le dépôt du 
                  <span class="font-weight-bold">formulaire de déclaration approprié</span>. Enfin, toutes les conditions prévues au Règlement ainsi que 
                  celles contenues au chapitre VI.3 du Code des professions doivent être satisfaites en tout temps par le membre de la société. 
                  (Voir <a href="https://www.odq.qc.ca/dentiste/gestion-de-ma-pratique/exercice-en-societe/" target="_blank">Lien vers formulaires.</a>)`,
            p3: "À défaut de produire la documentation requise par la situation qui vous concerne, l’article 1 du Règlement stipule que :",
            quote:
              "« Le membre cesse d’être autorisé à exercer ses activités professionnelles au sein d’une société s’il ne respecte plus les conditions prévues au présent règlement ou au chapitre VI.3 du Code des professions. »",
            odq_2:
              "<span class='font-weight-bold'>TOUTE</span> omission de fournir les renseignements adéquats à l’Ordre ou toute erreur dans les renseignements fournis pourrait occasionner un délai dans le traitement du dossier de la société.",
          },
          amendedDeclaration: "Déclaration modificative",
          annualDeclarationWithAmendments:
            "Déclaration annuelle avec modifications au {{annualDate}}",
          viewSummary: "Sommaire",
          downloadNotice: "Capsules d'information",
          section1: {
            title: "Informations sur la société",
            area1_1: {
              title: "Identification de la société",
              titleHtml:
                "Identification de la société <span class='importantText small-text-normal'>(Champ obligatoire)</span>",
              PartnershipCompanyName: "Nom de la société",
              QuebecEnterpriseNumber: "Numéro d'entreprise du Québec (NEQ)",
            },
            area1_2: {
              title: "Adresse du siège social",
              titleNote:
                "<span class='importantText small-text-normal'>(À remplir si changement seulement)</span>",
              address: {
                Line1: "Ligne 1",
                Line2: "Ligne 2",
                City: "Municipalité / Ville",
                Prov: "Province / État",
                PostalCode: "Code postal",
                Country: "Pays",
              },
            },
            area2: {
              title: "Autres noms utilisés par la société",
              note: "<span class='font-weight-bold'>Note:</span>",
              noteDetail:
                "Dans tous les cas, les noms doivent également avoir été inscrits au REQ.",
              otherName: "Autre nom",
              addition: "ajout",
              deletion: "retrait",
              addOtherCompany: "Ajouter un autre nom",
              removeOtherName: "Retirer l´autre nom {{otherName}}",
              endDate: "Date de fin",
              warning:
                "<p>TOUT nom sous lequel s’affiche la société DOIT être inscrit auprès de l’Ordre. Le cas échéant, veuillez <span class='font-weight-bold'>déclarer TOUTE MODIFICATION</span> apportée auprès du REQ (ajout/retrait) à la liste des noms ci-dessous.</p><p>Sous réserve des articles 3.09.01 et suivants du Code de déontologie ainsi que de l’article 36 de la Loi sur les dentistes, <span class='font-weight-bold'>l’Ordre se réserve le droit d’exiger le retrait de toute dénomination sociale et/ou autre nom qui contrevient à ces articles.</span></p><p>L’utilisation d’un nom/ou autre nom qui n’est pas approuvé par l’Ordre pourrait avoir une influence sur l’autorisation de la société.</p>",
            },
            area3: {
              title: "Membre répondant / répondant substitut",
              information:
                "<ol class='numberedList'><li>Le répondant/répondant substitut <span class='font-weight-bold'>DOIT</span> exercer ses activités professionnelles au Québec, au sein de la société et à l’établissement pour lequel il agit à ce titre.</li><li>Lorsque, pour un établissement de la société, <span class='font-weight-bold'>AUCUN</span> actionnaire/associé n’y exerce ses activités professionnelles, un membre de l’Ordre <span class='font-weight-bold'>DEVRA</span> néanmoins être désigné pour agir à ce titre pour chacun des établissements concernés (p. ex. : travailleur autonome, employé).</li><li>Le(s) répondant(s) <span class='font-weight-bold'>DOIT/DOIVENT</span> signer la <span class='font-weight-bold'>Convention d’acceptation du répondant</span> ci-dessous.</li><li>Lorsqu’un répondant <span class='font-weight-bold'>CESSE</span> d’être la personne <span class='font-weight-bold'>désignée</span> pour agir à ce titre, il <span class='font-weight-bold'>DOIT</span> s’assurer qu’un nouveau répondant est <span class='font-weight-bold'>désigné</span> et transmettre à l’Ordre une nouvelle <span class='font-weight-bold'>Convention d’acceptation du répondant.</span></li></ol>",
              informationNote:
                "<span class='text-danger font-weight-bold'>N.B.</span> Un <span class='text-danger font-weight-bold'>répondant substitut</span> par établissement doit être désigné <span class='font-weight-bold'>uniquement</span> si plus d’un membre de l’Ordre exerce ses activités professionnelles au sein de la société.",
              convention: {
                title: "CONVENTION D’ACCEPTATION DU RÉPONDANT",
              },
              warning:
                "<ol><li> Le répondant/répondant substitut <span class='font-weight-bold'>DOIT</span> exercer ses activités professionnelles au Québec, au sein de la société et à l’établissement pour lequel il agit à ce titre. </li><li> Lorsque, pour un établissement de la société, <span class='font-weight-bold'>AUCUN</span> actionnaire/associé n’y exerce ses activités professionnelles, un membre de l’Ordre <span class='font-weight-bold'>DEVRA</span> néanmoins être désigné pour agir à ce titre pour chacun des établissements concernés (p. ex. : travailleur autonome, employé).</li><li> Si ce n’est déjà fait, le formulaire <span class='font-weight-bold'>Convention d’acceptation du répondant</span> DOIT ÊTRE rempli conjointement avec l’un des actionnaires et <span class='font-weight-bold'>TÉLÉVERSÉ</span> à la section 8 de la déclaration.</li><li> Lorsqu’un répondant <span class='font-weight-bold'>CESSE</span> d’être la personne désignée pour agir à ce titre, il <span class='font-weight-bold'>DOIT</span> s’assurer qu’un nouveau répondant est désigné et transmettre à l’Ordre une nouvelle Convention d’acceptation du répondant. </li></ol><p>Le formulaire <span class='font-weight-bold'>Convention d’acceptation du répondant</span> est disponible au www.odq.qc.ca, section Membres – Études et Demandes de permis – Exercice en société.</p><p>N. B. : <span class='font-weight-bold'>Un répondant substitut</span> par établissement <span class='font-weight-bold'>doit être désigné</span> si plus d’un actionnaire/associé membre de l’Ordre détient des actions/parts sociales dans la société OU lorsque le répondant n’exerce pas dans tous les établissements EXPLOITÉS par la société.</p>",
              area3_1: {
                nameMemberAnsweringRequiredTitle:
                  "Prénom et nom du membre répondant <span class='importantText small-text-normal'>(Champ obligatoire)</span>",
                nameMemberAnswering: "Membre répondant",
                licenseNumber: "Numéro de permis",
                nochange: "Aucun changement",
                change: "Modification",
                question:
                  "<span class='importantText'>Exercez-vous la profession dans tous les établissements </span><span class='important-text-bold'>EXPLOITÉS</span><span class='importantText'> par la société?</span>",
                questionTitle:
                  "Exercez-vous la profession dans tous les établissements exploités par la société?",
                yes: "Oui",
                no: "Non",
                noNote:
                  "Si la réponse est Non, une <span class='font-weight-bold'>Convention d’acceptation du répondant</span> doit être signée.",
                nameMemberAnsweringSubstitutTitle:
                  "Prénom et nom du membre <span class='font-weight-bold'>répondant substitut</span> <span class='importantText small-text-normal'>(Le cas échéant)</span>",
                nameMemberAnsweringSubstitut: "Membre répondant substitut",
                article_1:
                  "<i class='fa fa-check fa-lg text-dark pt-2 pr-2'></i> Je confirme que je suis membre de l’Ordre et que j’ai été désigné pour agir pour l’ensemble des membres exerçant au sein de la société afin de remplir les conditions prévues aux articles 6 et 8.",
                article_2:
                  "<i class='fa fa-check fa-lg text-dark pt-2 pr-2'></i> Je confirme avoir accepté mon mandat en m’assurant de l’exactitude de tous les renseignements qui seront fournis à l’Ordre et j’accepte de répondre à toute demande formulée par le syndic, un inspecteur, un enquêteur ou tout autre représentant de l’Ordre.",
                article_3:
                  "<i class='fa fa-check fa-lg text-dark pt-2 pr-2'></i> De plus, je donne droit aux personnes, comités, instances disciplinaires et tribunaux visés à l’article 193 du Code des professions d’exiger de tout associé ou actionnaire la communication et l’obtention d’un document mentionné à l’article 13 du Règlement ou d’une copie d’un tel document.",
                article_4:
                  "<i class='fa fa-check fa-lg text-dark pt-2 pr-2'></i> Je confirme être dûment informé de mon obligation de transmettre, immédiatement, le formulaire prévu à cet effet, advenant que je démissionne de mon mandat de répondant.",
                attestation: "Attestation",
                attestationRequired: "L'attestation est requise",
                attestationInfo:
                  "Je, <span class='font-weight-bold p-0'> Dr {{memberName}} </span>, affirme que tous les renseignements fournis sont exacts et véridiques, le <span class='font-weight-bold p-0'>{{attestationDate}} </span.",
              },
            },
            area4: {
              title:
                "Nom et adresse de <span class='font-weight-bold p-0'>TOUS</span> les établissements situés au Québec et qui sont exploités par la société et liste des membres de l’Ordre qui y exercent",
              establishmentInformation:
                "Pour chaque membre de l'Ordre spécifiez le statut et la responsabilité (le cas échéant) au sein de votre société.",
              institution: {
                exploitedByLegalEntity:
                  "Cet établissement <span class='font-weight-bold'>EST EXPLOITÉ</span> par la société",
                notExploitedByLegalEntity:
                  "Cet établissement <span class='font-weight-bold'>N'EST PAS EXPLOITÉ</span> par la société",
                isExploitedByLegalEntity: "Exploité par la société",
                addInstitution: "ajout/établissement",
                removeInstitution: "retrait/établissement",
                editInstitution: "modification/établissement",
                name: "ÉTABLISSEMENT",
                address: {
                  No: "N°",
                  Street: "Rue",
                  City: "Municipalité / Ville",
                  Prov: "Province / État",
                  PostalCode: "Code postal",
                  Country: "Pays",
                },
                nameInstitution: "Nom de l’établissement",
                addInstitutionButton: "Ajouter un autre établissement",
                memberList: {
                  nameMember: "Membre de l’Ordre Nom, Prénom",
                  permitNumber: "Numéro de permis",
                  status: "Statut(s)",
                  addMember: "ajout",
                  removeMember: "Retrait",
                  removeThisMember: "Retirer ce membre",
                  amendmentMember: "Modification",
                  addMemberButton: " Ajouter un autre membre",
                  responsibility: "Responsabilité",
                  responsibilityOptions: {
                    Primary: "Répondant de société",
                    Substitute: "Répondant substitut de société",
                    PrimaryEstablisment: "Répondant d'établissement",
                    None: "N/A",
                  },
                  state: "Statut",
                  stateOptions: {
                    Administrator: "Exerce une fonction de gestion",
                    Employee: "Employé membre de l´Ordre",
                    SelfEmployed: "Travailleur autonome membre de l´Ordre",
                    EmployeeSelfEmployed: 'Membre qui exerce à l’établissement'
                  },
                },
              },
              warning:
                "<p><span class='font-weight-bold'>Établissement <span class='text-danger'>EXPLOITÉ</span> par la société</span><br>On entend par société qui <span class='font-weight-bold'>EXPLOITE</span> un établissement un lieu physique où s’exercent les activités professionnelles. Cet établissement DOIT être inscrit dans cette section</p><p><span class='font-weight-bold'>Établissement qui <span class='text-danger'>N’EST pas EXPLOITÉ</span> par la société </span><br>À l’inverse, une société qui <span class='font-weight-bold'>N’EXPLOITE</span> pas l’établissement correspond à celle qui reçoit uniquement des honoraires découlant de la prestation de services professionnels de médecine dentaire. Cet établissement n’a pas à être inscrit dans cette section.</p><p><span class='font-weight-bold'>Toute</span> adresse inscrite dans cette section <span class='font-weight-bold'>sera inscrite au Registre des sociétés</span> de l’Ordre <span class='font-weight-bold'>seulement.</span></p><p class='font-weight-bold'>Article 60 du Code des professions</p><p>Chaque membre de l’Ordre qui exerce dans ces établissements <span class='font-weight-bold'>est responsable de la mise à jour de TOUTES ses adresses</span> de pratique au tableau de l’Ordre. </p>",
            },
            area5: {
              title: "Nombre d'administrateurs",
              titleHtml:
                "<span class='text-danger small-text-normal''>(Champ Obligatoire)</span>",
              note: "<span class='font-weight-bold'>NOTE</span>",
              noteDetail:
                "<span class='font-weight-bold'>Seuls les membres de l’Ordre peuvent être nommés pour exercer des fonctions de gestion au sein de la société, y compris, le cas échéant, la fonction d’administrateur, d’officier ou de dirigeant.</span>",
              information:
                "Nombre d’administrateurs siégeant au conseil d’administration de la société par actions ou au conseil de gestion interne de la société en nom collectif à responsabilité limitée :",
              numberAdmin: "Nombre d'administrateurs",
            },
            area6: {
              title:
                "Répartition des actions ou des parts sociales AVEC DROIT DE VOTE de la société",
              note: "<span class='text-danger'>Note: à remplir dès qu’un changement survient aux sections 3 ou 4 du présent formulaire</span>",
              number_1:
                "Pourcentage d’actions ou parts sociales avec droit de vote détenues par des membres de l’Ordre exclusivement:",
              number_2:
                "Pourcentage d’actions ou parts sociales avec droit de vote détenues par personnes morales et/ou fiducies:",
              number_3:
                "Pourcentage TOTAL d’actions ou de parts sociales avec droit de vote émises par la société:",
              warning:
                "<span class='font-weight-bold'>TOUJOURS VALIDER</span> les informations de cette section avec votre représentant ou votre conseiller juridique",
            },
            area7: {
              title: "Répartition des actions SANS DROIT DE VOTE de la société",
              note: "<span class='text-danger'>Note: à remplir dès qu’un changement survient aux sections 5 ou 6 du présent formulaire</span>",
              number_1:
                "Pourcentage d’actions sans droit de vote détenues par des membres de l’Ordre et/ou conjoint(e) et/ou parent(s) du membre:",
              number_2:
                "Pourcentage d’actions sans droit de vote détenues par des personnes morales et/ou fiducies:",
              number_3:
                "Pourcentage TOTAL d’actions sans droit de vote émises par la société:",
              warning:
                "<span class='font-weight-bold'>TOUJOURS VALIDER</span> les informations de cette section avec votre représentant ou votre conseiller juridique",
            },
          },
          section2: {
            title:
              `Information sur les membres détenant des actions ou parts sociales <span class="font-weight-bold text-danger">AVEC DROIT DE VOTE</span> dans la société`,
            titleHtml:
              `Information sur les membres détenant des actions ou parts sociales <span class="font-weight-bold text-danger">AVEC DROIT DE VOTE</span> dans la société`,
            areaTitle: "MEMBRE",
            addition: "addition",
            deletion: "deletion",
            amendment: "amendment",
            numberVoting:
              "Pourcentage d’actions ou de parts sociales avec droit de vote",
            startDate: "Date d’effet",
            endDate: "Date de fin",
            firstName: "Prénom",
            lastName: "Nom du membre",
            or: "OU",
            yes: "J’atteste et confirme qu’en date des présentes, cette personne souscrit au Fonds d’assurance-responsabilité professionnelle de l’Ordre des dentistes du Québec (FARPODQ) et ne fait l’objet d’aucune exemption. Je m’engage à aviser immédiatement l’Ordre par écrit si le maintien de cette souscription devait être interrompu pour quelque raison que ce soit.",
            no: "J’atteste et confirme qu’en date des présentes, cette personne est inscrite au tableau de l’ODQ à la classe « membre inactif » ou « exemptée » de souscrire au FARPODQ.",
            personPractise:
              "<span class='text-danger font-weight-bold'>Cette personne exerce-t-elle sa profession au sein de la société?</span>",
            personPractiseTitle:
              "Cette personne exerce-t-elle sa profession au sein de la société?",
            adressTitle:
              "Adresse de pratique principale au sein de la société:",
            // tslint:disable-next-line: max-line-length
            status:
              "Statut(s) ou fonction(s) au sein de la société <span class='text-danger'>(Cochez le ou les choix applicables)</span>",
            statusTitle: "Statut(s) ou fonction(s) au sein de la société",
            shareholder: "Actionnaire",
            partner: "Associé",
            officer: "Dirigeant",
            director: "Administrateur",
            employee: "Employé",
            management: "Exerce une fonction de gestion",
            addMemberButton: "Ajouter un nouveau membre",
            removeThisMember: "Retirer ce membre",
          },
          section3: {
            addMemberButton: "Ajouter un nouveau membre actionnaire",
            title:
              `Information sur les personnes morales/fiducies détenant des actions ou des parts sociales <span class="font-weight-bold text-danger">AVEC DROIT DE VOTE</span> dans la société`,
            titleHtml:
              `Information sur les personnes morales/fiducies détenant des actions ou des parts sociales <span class="font-weight-bold text-danger">AVEC DROIT DE VOTE</span> dans la société`,
            areaTitle: "IDENTIFICATION DE LA PERSONNE MORALE/FIDUCIE",
            group1_1: {
              add: "ajout",
              remove: "retrait",
              edit: "modification",
            },
            group1_2: {
              person: "Personne morale",
              trust: "Fiducie",
              company: "Aucune fiducie ou personne morale ne détient des parts votantes",
            },
            group1_3: {
              label:
                `Pourcentage d’actions ou de parts sociales avec droit de vote :`,
            },
            group1_4: {
              startDate: "Date d’effet",
              endDate: "Date de fin ",
            },
            group2: {
              name: "Nom de la personne morale / fiducie",
              moralPerson: "Nom de la personne morale",
              trust: "Nom de la fiducie",
              neq: "Numéro d’entreprise du Québec (NEQ)",
              naf: "Numéro de l’Acte de fiducie (NAF)",
              combinedNeqNaf:
                "Numéro d’entreprise du Québec (NEQ) / Numéro de l’Acte de fiducie (NAF)",
            },
            group3: {
              title: "SIÈGE SOCIAL",
              titleSummary: "Siège social",
              address: {
                no: "N°",
                street: "RUE",
                city: "MUNICIPALITÉ/VILLE",
                prov: "PROVINCE/ÉTAT",
                postalCode: "CODE POSTAL",
                country: "PAYS",
              },
            },
            group4: {
              title: "Actionnaire/Fiduciaire - MEMBRE DE L'ORDRE",
              titleMoralPerson: "Actionnaire - MEMBRE DE L'ORDRE",
              titleTrust: "Fiduciaire - MEMBRE DE L'ORDRE",
              titleHtml:
                "Statut(s) ou fonction(s) au sein de la société du ou des détenteurs d’actions de l’entité juridique/fiduciaires de la fiducie <span class='importantText small-text-normal'>(Cochez le ou les choix applicables)</span>",
              numberOfTrustees:
                "Lorsque la situation s’applique, veuillez indiquer le <span class='font-weight-bold p-0'>nombre de fiduciaires</span> de la fiducie :",
              odqPermit: "Permis ODQ",
              odqMember: "Membre ODQ",
              odqPermitPlaceholder: "N°",
              roles: {
                partner: "Associé",
                shareholder: "Actionnaire",
                trustee: "Fiduciaire",
                director: "Administrateur",
                officer: "Dirigeant",
                employee: "Employé",
                managementDuties: "Exerce une fonction de gestion",
                practicesWithinPartnersip: "Exerce au sein de la société",
              },
              addStatus: "Ajouter un autre détenteur/fiduciaire",
              addMoralPersonMember: "Ajouter un membre actionnaire",
              addTrustMember: "Ajouter un fiduciaire-membre",
            },
            addLegalForm: "Ajouter une autre entité juridique/fiducie",
            addMoralPerson:
              "Ajouter une autre personne morale/fiducie actionnaire",
            addTrust: "Ajouter une autre fiducie actionnaire",
            summaryDialog: {
              countOfTrusteesError:
                "Veuillez inscrire tous les fiduciaires avant de continuer.",
              votingPartsCountError:
                `<span class='font-weight-bold'>Le TOTAL</span> des pourcentages d'actions ou de part sociales <span class="font-weight-bold text-danger">AVEC DROIT DE VOTE</span> doit être égale à 100%. Veuillez corriger les informations dans les sections 3 et 4.`,
              votingPartsCountSucces:
                "<span class='font-weight-bold'>Le TOTAL</span> des pourcentages est égal à 100%. Vous pouvez continuer.",
              adjust: "Corriger",
              nextStep: "Continuer",
            },
          },
          section4: {
            title:
              `Information sur les personnes physiques détenant des actions <span class="font-weight-bold text-danger">SANS DROIT DE VOTE</span> dans la société`,
            titleHtml:
              `Information sur les personnes physiques détenant des actions <span class="font-weight-bold text-danger">SANS DROIT DE VOTE</span> dans la société`,
            areaTitle: "PERSONNES PHYSIQUES",
            warning: {
              title: `Les actions/parts sociales <span class="font-weight-bold text-danger">SANS DROIT DE VOTE</span> inscrites dans cette section <span class="font-weight-bold">SONT détenues</span> par :`,
              list: `<ul>
              <li>un(des) membre(s) de l’Ordre</li>
              <li>le conjoint d’un(des) membre(s) de l’Ordre détenant des actions</li>
              <li>un parent, en ligne directe ou collatérale privilégiée d’un (des) membre(s) de l’Ordre détenant des actions</li>
              </ul>`,
              note: `
              <p>
                <span class='important-text-bold'>S’il y a lieu</span>, pour les <span class='font-weight-bold'>PERSONNES MORALES/FIDUCIES</span> détentrices d’actions/parts sociales
                <span class="font-weight-bold text-danger">SANS DROIT DE VOTE</span>, vous devez remplir la <span class='important-text-bold'>SECTION 6</span>.
              </p>
              <p>
              <span class='font-weight-bold'>À NOTER</span> : Une <span class='font-weight-bold'>PERSONNE MORALE</span> ou une <span class='font-weight-bold'>FIDUCIE</span> ne
              <span class='font-weight-bold'>CORRESPOND PAS</span> à un membre de l’Ordre ou de toute autre personne physique. Il s’agit d’une
              <span class='font-weight-bold'>ENTITÉ JURIDIQUE</span> qui peut détenir des actions, des titres de participation et/ou d’autres droits dans votre société.
              </p>
              `,
            },
            group1_1: {
              add: "ajout",
              remove: "retrait",
              edit: "modification",
            },
            group1_2: {
              label: "Pourcentage d’actions sans droit de vote :",
            },
            group1_3: {
              odqPermitNumber: "Membre ODQ, numéro de permis",
              startDate: "Date d’effet",
              endDate: "Date de fin",
            },
            group2: {
              shareholderLastName: "Nom du détenteur d’actions",
              shareholderFirstName: "Prénom",
            },
            group3: {
              title: "Adresse résidentielle",
            },
            group4: {
              title:
                "STATUT(S) OU FONCTION(S) AU SEIN DE LA SOCIÉTÉ <span class='importantText small-text-normal'>(Cochez le ou les choix applicables)</span>",
              odqMember: {
                title:
                  "<b>Actionnaire – <span class='importantText'>Membre de l’Ordre</span></b>",
                director: "Administrateur",
                officer: "Dirigeant",
                managementDuties: "Exerce une fonction de gestion",
              },
              spouseOrRelative: {
                title:
                  "<b>Actionnaire – <span class='importantText'>Conjoint(e)/parent</span></b>",
                subtitle: "LIEN AVEC L’ACTIONNAIRE MEMBRE DE L’ORDRE",
                relatedToMember: "Relié au membre",
                relationship: "À quel titre?",
                relationships: {
                  Spouse: "Conjoint(e)",
                  Son: "Fils",
                  Daughter: "Fille",
                  Father: "Père",
                  Mother: "Mère",
                  Sister: "Sœur",
                  Brother: "Frère",
                  Cousin: "Cousin",
                },
              },
            },
            addPerson: "Ajouter une autre personne physique actionnaire",
            memberOrParentEnum: {
              member: "Membre de l'Ordre",
              parent: "Conjoint(e)/parent d'un membre de l'Ordre",
            },
          },
          section5: {
            title:
              `Information sur les personnes morales/fiducies détenant des actions <span class="font-weight-bold text-danger">SANS DROIT DE VOTE</span> dans la société`,
            titleHtml:
              `Information sur les personnes morales/fiducies détenant des actions <span class="font-weight-bold text-danger">SANS DROIT DE VOTE</span> dans la société`,
            addPerson: "Ajouter une autre personne morale ou une fiducie",
            warning: {
              point_1_li: `<p class='font-weight-bold'>Une persone morale/autre entreprise</p>
                 <p>Les droits de vote rattachés aux actions, parts sociales ou autres titres <span class="importantText">de la personne morale</span> qui 
                 détient des actions/parts sociales <span class="font-weight-bold text-danger">AVEC DROIT DE VOTE<span> de la société identifiée à la section 2.1 <span class='font-weight-bold'>DOIVENT</span> :
                 <span class="important-text-bold">EXCLUSIVEMENT ET EN TOTALITÉ</span> être détenus par un/des membre(s) de l’Ordre.
                 </p>`,
              point_1_sublist:
                "<ul><li>un membre de l'Ordre</li><li>un conjoint d'un membre de l'Ordre détenant des actions</li><li>un parent, en ligne directe ou collatérale, d'un membre de l'Ordre détenant des actions</li></ul>",
              or: "OU",
              point_2_li:
                "<p class='font-weight-bold'>Une fiducie familiale</p><p><span class='font-weight-bold'>Le(s) FIDUCIAIRE(S)</span> (et non les bénéficiaires) d'une Fiducie familiale qui détient des <span class='font-weight-bold'>actions SANS droit de vote:</span> au sein de la société <span class='font-weight-bold'>PEUVENT ÊTRE :</span></p>",
              point_2_sublist:
                "<ul><li>un membre de l'Ordre</li><li>un conjoint d'un membre de l'Ordre détenant des actions</li><li>un parent, en ligne directe ou collatérale, d'un membre de l'Ordre détenant des actions</li></ul>",
            },
            identification: {
              title: "IDENTIFICATION DE LA PERSONNE MORALE/FIDUCIE ",
              legalForm: {
                legalPerson: "Personne morale",
                trust: "Fiducie",
                otherCompany: "Autre entreprise",
                none: "Aucune fiducie ou personne morale ne détient des parts non-votantes",
              },
              legalFormOperation: {
                add: "ajout",
                deletion: "retrait",
                amendments: "modification",
              },
              numberNonVotingShares:
                "Pourcentage d'actions sans droit de vote:",
              effectiveDate: "Date d'effet",
              endingDate: "Date de fin",
              legalEntityName: "Nom de la personne / fiducie",
              legalPerson: "Nom de la personne morale",
              trust: "Nom de la fiducie",
              neq: "Numéro d’entreprise de Québec (NEQ)",
              naf: "Numéro de l’Acte de fiducie (NAF)",
              combinedNeqNaf:
                "Numéro d’entreprise du Québec (NEQ) / Numéro de l’Acte de fiducie (NAF)",
            },
            headOffice: {
              address: {
                no: "N°",
                street: "Rue",
                city: "Municipalité / Ville",
                prov: "Province / État",
                postalCode: "Code postal",
                country: "Pays",
              },
            },
            countOfTrusteesError_part1:
              "Vous avez inscrit un nombre de fiduciaires égal à ",
            countOfTrusteesError_part2:
              " . Ce nombre ne correspond pas à la liste des membres inscrits qui est égal à ",
            countOfTrusteesError_part3: ".",
            shareholders: {
              titleLegalPerson:
                "DÉTENTEUR(S) DES ACTIONS DE LA PERSONNE MORALE",
              titleTrust: "FIDUCIAIRES DE LA FIDUCIE",
              trusteeInTrust:
                "LORSQUE LA SITUATION S’APPLIQUE, VEUILLEZ INDIQUER LE NOMBRE DE FIDUCIAIRES DE LA FIDUCIE :",
              trusteeInTrustSummary:
                "Lorsque la situation s’applique, veuillez indiquer le nombre de fiduciaires de la fiducie :",
              subtitle: {
                shareholder: "Actionnaire(s)",
                trustee: "Fiduciaire(s)",
                ofTrust: "de la fiducie",
                ofLegalPerson: "de la personne morale",
                ofOtherCompany: "de l'autre entreprise",
              },
              odqMember: {
                title: "<span class='text-danger'>Membre(s) de l’Ordre</span>",
                name: "Nom du membre de l'Ordre",
                permitNumber: "Membre ODQ, numéro de permis",
                type: {
                  shareholder: "Actionnaire",
                  trustee: "Fiduciaire",
                  director: "Administrateur",
                  officer: "Dirigeant",
                  managementDuties: "Exerce une fonction de gestion",
                },
                addOdqMember: "Ajouter un membre",
                addShareholder: "Ajouter un membre",
              },
              spouseRelative: {
                title: "<span class='text-danger'>Conjoint(e)/parent(s)</span>",
                firstName: "Prénom du conjoint(e)/parent",
                lastName: "Nom du conjoint(e)/parent",
                permitNumber: "Membre ODQ, numéro de permis",
                type: {
                  shareholder: "Actionnaire",
                  trustee: "Fiduciaire",
                  spouse: "Conjointe",
                  relative: "Parent",
                },
                relationType: "A quel titre?",
                addSpouseRelative: "Ajouter conjoint(e)/parent(s)",
              },
            },
            summaryDialog: {
              nonVotingPartsCountError:
                "Le <span class='font-weight-bold'>TOTAL</span> des pourcentages d'actions <span class='font-weight-bold'>sans droit de vote DOIT</span> être égale à 100%. Veuillez corriger les informations dans les sections 5 et 6.",
              nonVotingPartsCountSucces: `Le <span class='font-weight-bold'>TOTAL</span> des pourcentages <span class='font-weight-bold'>PEUT</span> être égal à 0% si
                <span class='font-weight-bold'>aucune</span> action <span class='font-weight-bold'>SANS</span> droit de vote n’a été émise par
                votre société.<br/>Si des actions SANS droit de vote ont été émises, il DOIT être égal à 100%.
                `,
            },
          },
          section6: {
            title: "Attestation assermentée et autorisation",
            titleHtml: "Attestation assermentée et autorisation",
            subtitle:
              "ATTESTATION, AUTORISATION ÉCRITE IRRÉVOCABLE ET ASSERMENTATION",
            representative: "NOM DU MEMBRE/RÉPONDANT (PRÉNOM, NOM)",
            permitNumber: "NUMERO DE PERMIS",
            attest:
              "Atteste que je suis membre de l’Ordre et, le cas échéant, la personne autorisée par la société à signer la présente déclaration, que les renseignements déclarés sont complets, conformes et exacts et que les documents requis accompagnent la présente déclaration; j’atteste de plus que la détention des parts sociales ou actions ainsi que les règles d’administration de la société respectent les conditions du Règlement.",
            authorize:
              "De plus, je donne le droit aux personnes, comités, instances disciplinaires et tribunaux visés à l’article 192 du Code des professions d’exiger de tout associé ou actionnaire la communication et l’obtention d’un document mentionné à l’article 13 du Règlement ou d’une copie d’un tel document.",
            signedSworn: "Signé et assermenté devant moi :",
            signTown: "à (ville)",
            signDate: "ce",
            representativeSign: "SIGNATURE DU RÉPONDANT",
            oathSign: "SIGNATURE DU COMMISSAIRE À L’ASSERMENTATION",
            oathDistrict: "pour le district de",
            oathCommissionTitle: "COMMISSAIRE À L’ASSERMENTATION",
            oathCommissionText:
              "L’assermentation du formulaire Déclaration d’exercice de la médecine dentaire en société peut se faire soit par un avocat, un notaire ou un commissaire à l’assermentation. Si vous choisissez de faire assermenter ce document par un commissaire à l’assermentation, voici un lien qui vous permettra d’en trouver facilement un dans votre secteur :<br>http://www.assermentation.justice.gouv.qc.ca/ServicesPublicsConsultation/Commissaires/Proximite/Criteres.aspx",
          },
          section7: {
            mandatoryDocumentWarning:
              "<span class='text-danger font-weight-bold'>OBLIGATOIRE POUR TOUTES LES SOCIÉTÉS : vous devez TÉLÉVERSER une copie, à jour, de l’État des renseignements de votre société, lequel vous pourrez obtenir en effectuant une recherche à partir du site internet du <a target='blank' href='https://www.registreentreprises.gouv.qc.ca/RQAnonymeGR/GR/GR03/GR03A2_19A_PIU_RechEnt_PC/PageRechSimple.aspx?T1.CodeService=S00436&Clng=F&WT.co_f=28f055c33672fe69fc31614102068356'>Registraire des entreprises du Québec (REQ)</a>, en cliquant <a target='blank' href='https://www.registreentreprises.gouv.qc.ca/RQAnonymeGR/GR/GR03/GR03A2_19A_PIU_RechEnt_PC/PageRechSimple.aspx?T1.CodeService=S00436&Clng=F&WT.co_f=28f055c33672fe69fc31614102068356'>ICI</a>. </span>",
            documentType: {
              Other: "Autre documentation",
              AnyCertNameChByReq:
                "Certificat de modification du nom délivré par le REQ",
              CertAmendDeclWithReq:
                "Déclaration de mise à jour courante déposée au REQ",
              CertAmalgByReq: "Certificat de fusion délivré par le REQ",
              CertAmalgByIsde:
                "Certificat de fusion délivré par Corporations Canada",
              CertNameChByCorpsCan:
                "Certificat de modification du nom délivré par Corporations Canada",
              DeclAttestNameChWithReq:
                "Déclaration d'atteste de changement de nom déposée au REQ",
              DeclShortFormMergerWithReq:
                "Déclaration de fusion simplifiée produite au REQ",
              OrigFrmAgreemtDentistRecsXfer:
                "Formulaire de convention entre un dentiste cédant ses dossiers et le cessionnaire des dossiers",
              ConfirmationAcceptanceRepresentative:
                "Convention d´acceptation d’un répondant",
              CompanyInformationStatementAtREQ: "État des renseignements (REQ)",
            },
            documentList: {
              typeName: "Type de document",
              savedAt: "Date",
              savedBy: "Enregistré par",
              upload: "Télécharger",
              remove: "Supprimer",
            },
          },
        },
      },
      endOfPractice: {
        document: {
          copyCertificateAmalgamationIssuedREQOrOtherAuthority:
            "Copie du certificat de fusion délivré par le REQ ou par toute autre autorité compétente",
          copyAmendingDeclarationAttestingAmalgamationFiledWithREQOrOtherAuthority:
            "Copie de toute déclaration modificative ou déclaration de mise à jour courante qui atteste de la transaction de fusion et ayant été produite auprès du REQ ou de toute autre autorité compétente",
        },
        tabTitle: "Déclaration de fin d’exercice en société",
        title: "Déclaration de fin d’exercice en société",
        directive: {
          startModification: {
            title: "Commencer la modification",
            subTitle:
              "En cliquant ici, vous allez être redirigé ver la section de Déclaration de fin d’exercice en société",
          },
        },
        directiveTitle: "Directives",
        endOfPractice:
          "Déclaration de fin d’exercice en société <span class='text-danger small-text-normal'></span>",
        endOfPracticeAnnual:
          "Déclaration annuelle de fin d’exercice en société au {{annualDate}}, <span class='text-danger small-text-normal'></span>",
        directiveNote:
          "<span class='text-danger font-weight-bold'>FRAIS : Voir le tableau Frais et pénalités au www.odq.qc.ca – Études et demandes de permis – Exercice en société.</span>",
        section0: {
          title: "Informations sur la société",
          area1: {
            title: "Identification de la société",
            nameOfPartnership: "Nom de la société",
            neq: "Numéro d’entreprise du Québec (NEQ)",
          },
          area2: {
            title: "Date d’effet",
          },
          area3: {
            title: "Motif",
            notes:
              "Veuillez cocher le choix applicable et, le cas échéant, remplir la section appropriée du présent formulaire.",
            rowA: "Changement de vocation",
            rowAHtml:
              "Changement de vocation <span class='text-danger'>(Veuillez remplir la section 1)</span>",
            rowB: "Vente d’actions ou de parts",
            rowBHtml:
              "Vente d’actions ou de parts <span class='text-danger'>(Veuillez remplir la section 2)</span>",
            rowC: "Fusion simplifiée/fusion ordinaire",
            rowCHtml:
              "Fusion simplifiée/fusion ordinaire <span class='text-danger'>(Veuillez remplir la section 3)</span>",
            rowD: {
              title: "Radiation volontaire (radiation sur demande)",
              titleHtml: "Radiation volontaire (radiation sur demande)",
              point1:
                "Joindre une copie de toute déclaration déposée auprès de l’autorité compétente (p. ex. Registraire des entreprises du Québec [REQ], Corporations Canada)",
            },
            rowE: {
              title: "Liquidation/dissolution",
              point1:
                "Joindre une copie du certificat de dissolution délivré par l’autorité compétente, le cas échéant",
              point2:
                "Joindre une copie de toute déclaration déposée auprès de l’autorité compétente (p. ex. REQ, Corporations Canada)",
            },
            rowF: {
              title: "Cession de biens, faillite",
              point1:
                "Joindre une copie de toute déclaration déposée auprès de l’autorité compétente (p. ex. REQ, Corporations Canada) ou de tout document officiel qui atteste de la date d’effet de la cessation des opérations",
            },
          },
        },
        section1: {
          title: "Changement de vocation",
          nameOfPartnership: "Nouveau nom de la société",
          activitySector: "Nouveau secteur d’activités",
          point1:
            "Joindre une copie du certificat de modification délivré par l’autorité compétente (p. ex. REQ, Corporations Canada)",
          point2:
            "Joindre une copie de toute déclaration ayant été produite auprès de l’autorité compétente relativement au changement de la nature des activités et du nom de la sociétédes activités et du nom de la société",
        },
        section2: {
          title: "Vente d’actions ou de parts",
          to: "En faveur de :",
          nameOfMember: "Nom du membre de l’ODQ ou de l’entité juridique",
          neq: "NEQ (Le cas échéant)",
          area1: {
            title: "Continuerez-vous d’exercer la profession?",
            yes: "Oui, à titre de:",
            employee: "Employé",
            selfEmployedWorker: "Travailleur autonome",
            clinicName: "Nom de la clinique",
            addressName: "Adresse de la clinique",
            owner: "Propriétaire",
            no: "Non (Veuillez communiquer avec l’Ordre afin de mettre à jour votre statut au tableau des membres.)",
          },
          area2: {
            title: "Avez-vous cédé des dossiers au cours de cette transaction?",
            yes: "Oui (Le formulaire Convention entre un dentiste cédant ses dossiers et son cessionnaire doit être signé – voir www.odq.qc.ca – Membres – Références et Formulaires)",
            yesHtml:
              "Oui (Le formulaire <span class='font-weight-bold'>Convention entre un dentiste cédant ses dossiers et son cessionnaire</span> doit être signé – voir www.odq.qc.ca – Membres – Références et Formulaires)",
            no: "Non, précisez :",
          },
        },
        section3: {
          title: "Fusion simplifiée/fusion ordinaire",
          notes:
            "À la suite d’une transaction de fusion, le répondant d’une société autorisée qui est «radiée d’office» après fusion doit transmettre une déclaration de fin d’exercice en société pour en informer l’Ordre.",
          noForm: "Aucune fusion",
          shortForm: "Fusion simplifiée",
          longForm: "Fusion ordinaire",
          resultingPartnership: "Société résultante :",
          resultingPartnershipNeq: "Nouveau NEQ",
          point1:
            "Joindre une copie du certificat de fusion délivré par le REQ ou par toute autre autorité compétente",
          point2:
            "Joindre une copie de toute déclaration modificative ou déclaration de mise à jour courante qui atteste de la transaction de fusion et ayant été produite auprès du REQ ou de toute autre autorité compétente",
          attestation: {
            title: "ATTESTATION",
            representative: "NOM DU RÉPONDANT (PRÉNOM, NOM)",
            permitNumber: "NUMÉRO DE PERMIS",
            note: "atteste de l’exactitude des renseignements fournis dans la présente déclaration.",
          },
        },
      },
      amalgamation: {
        menuTitle: "Fusion",
        title: "Déclaration de fusion",
        section1: {
          titleNote:
            "<h5 class='d-inline'><b>Tout autre changement, modification ou transaction</b></h5> intervenu à votre société comporte une obligation d’informer l’Ordre et de remplir le formulaire approprié dans les délais requis.",
          declaration: "<b>Déclaration de fusion</b>",
          annualDeclaration: "<b>Déclaration annuelle de fusion au 31 mars</b>",
          noteDeclaration:
            "<span class='text-danger pl-4'>(AUCUNS FRAIS)</span>",
          noteAnnualDeclaration:
            "<span class='text-danger pl-1'>(JOINDRE VOTRE CHÈQUE POUR LES FRAIS ADMINISTRATIFS)</span>",
        },
        section2: {
          title: "<b>IDENTIFICATION DE LA SOCIÉTÉ RÉSULTANT DE LA FUSION</b>",
          PartnershipCompanyName: "Nom de la société résultant de la fusion",
          QuebecEnterpriseNumber: "Numéro d’entreprise du Québec (NEQ)",
          dateAmalgamation: "Date de la fusion",
          amalgamationOf: {
            title: "<b>FUSION ENTRE LES SOCIÉTÉS SUIVANTES :</b>",
            namePartnershipCompany: "Nom de la société",
            QuebecEnterpriseNumber: "NEQ",
            addPartnershipCompany: "Ajouter autres sociétés",
          },
        },
        section3: {
          title: "<b>ATTESTATION</b>",
          reprisentative: "NOM DU RÉPONDANT/RÉPONDANT SUBSTITUT (PRÉNOM, NOM)",
          permitNumber: "NUMÉRO PERMIS",
          i: "JE,",
          attestVerified:
            "J’atteste avoir vérifié l’exactitude des renseignements fournis depuis la dernière déclaration.",
          attestConfirm:
            "J’atteste et confirme qu’en date de la présente, <span class='font-weight-bold'>aucune autre</span> modification n’est intervenue à la société depuis la dernière déclaration, et ce, conformément aux exigences du Règlement sur l’exercice de la profession de dentiste en société.",
          address: {
            title:
              "<span class='text-danger font-weight-bold'>À REMPLIR UNIQUEMENT EN CAS DE CHANGEMENT D’ADRESSE DU SIÈGE SOCIAL DE LA SOCIÉTÉ</span>",
            addressTitle: "NOUVELLE ADRESSE DU SIÈGE SOCIAL DE LA SOCIÉTÉ",
            note: "Note : L’adresse du siège social doit correspondre à l’adresse inscrite auprès du REQ (www.registreentreprises.gouv.qc.ca).",
          },
        },
      },
    },
    home: {
      menu: "Accueil",
      title: "Accueil - Portail de l’Ordre des dentistes du Québec",
      intro1:
        "Bienvenue sur le portail réservé aux membres de l’Ordre des dentistes du Québec.",
      intro2:
        "À partir de ce portail vous pouvez  remplir vos déclarations auprès de l’Ordre, y apporter des changements et davantage.",
      intro3:
        "Afin de respecter vos obligations pour l’année <b>{{years}}</b>, vous devez remplir les formulaires suivants et acquitter les montants exigés AVANT <b>le 1er avril {{currentYear}}</b>",
      intro4:
        "Selon votre profil professionnel dans nos systèmes en date du {{currentDate}}, voici les différents formulaires à remplir.",
      dentoform: "Dentoform",
      inscription: "Inscription annuelle au tableau de l'Ordre - ",
      inscriptionPeriod: "Cotisation 2026-2027",
      inscriptionUrl: "https://net.odq.qc.ca/cotisation/login.aspx",
      subscription:
        "Souscription au Fonds d’assurance responsabilité professionnelle pour 2026-2027",
      retreiveIdentificationCode:
        "Récupérer votre code d'identification/Vous devez réinitialiser votre mot de passe",
      annualRegistration:
        "Inscription annuelle et cotisation à l’Ordre des dentistes du Québec",
      subscriptionFARPODQ:
        "Souscription au Fonds d'assurance responsabilité de l'Ordre des dentistes du Québec",
      annualDeclaration:
        "Déclaration annuelle relative à votre société inscrite au registre de l’Ordre",
      memberNotRegisterForCurrentPeriod:
        "Vous n’avez pas de société inscrite au registre de l’Ordre pour cette période, vous n’avez donc pas de formulaire à remplir.",
      exerciseStatusInactive:
        "Votre statut est inactif pour cette période, vous n’avez pas donc pas à souscrire au Fonds d’assurance.",
      inscriptionStatusNoRegister:
        "Vous n’êtes pas inscrit pour cette période, vous n’avez pas à souscrire au Fonds d’assurance.",
      inscriptionStatusActifAndExempted:
        "Vous êtes actif mais vous avez une exemption d’assurance pour cette période, vous n’avez pas à souscrire au Fonds d’assurance.",
      fillFormula: "Veuillez remplir le formulaire en cliquant ici",
      createDentalAssistantAccount:
        "Inscription au registre des assistants(es) dentaires",
      payment: "Payer une facture",
      paymentForm: {
        title: "Informations de la facture",
        billNumber: "Numéro de facture",
        payerName: "Prénom et nom sur la facture",
        amount: "Montant total de la facture",
        search: "Rechercher",
        found: "Facture trouvée",
        searchAnother: "Rechercher une autre facture",
        notFoundMessage: "Nous n'arrivons pas à trouver de facture impayée avec les informations que vous avez fournies. Veuillez vérifier vos informations et réessayer.",
        payment: "Paiement",
        date: "Date",
        searchTitle: "Recherchez votre facture",
        mandatoryFields: "Les trois champs sont obligatoires et doivent correspondre exactement aux informations figurant sur votre facture.",
        hints: {
          billNumber: "Entrez le numéro complet figurant sur votre facture.",
          payerName: "Saisissez le prénom et le nom apparaissant dans la section « Facturé à » de votre facture.",
          amount: "Entrez le montant total indiqué sur la facture, taxes incluses."
        },
        importantInfo: {
          title: "Information importante",
          intro: "Cette section permet d'acquitter les factures émises par les différents services de l'Ordre des dentistes du Québec.",
          payableTitle: "Factures pouvant être acquittées ici",
          payableTitleShort: "Vous pouvez acquitter ici :",
          notPayableTitleShort: "Ne peuvent pas être acquittés ici :",
          payableDepartments: "Factures provenant de tous les départements de l'Ordre des dentistes du Québec.",
          payableFarpodqRecovery: "Factures de franchise du Fonds d'assurance responsabilité professionnelle (FARPODQ).",
          payableTraining: "Formations et activités de l'Ordre.",
          payableOtherServices: "Autres départements de l'Ordre.",
          notPayableTitle: "Factures ne pouvant pas être acquittées ici",
          notPayableFarpodq: "Les factures en provenance du Fonds d'assurance responsabilité professionnelle (FARPODQ).",
          notPayableRegistration: "L'inscription annuelle au tableau de l'Ordre.",
          notPayableMembershipFee: "La cotisation annuelle à l'Ordre.",
          notPayableAnnualDeclaration: "La déclaration annuelle relative à votre société.",
          footer: "Pour ces démarches, veuillez utiliser les formulaires disponibles dans les différentes sections du portail."
        },
        about: {
          title: "À propos de cette recherche",
          intro: "Cette section permet de retrouver et de payer une facture émise par l'Ordre des dentistes du Québec.",
          requirements: "Pour effectuer une recherche, vous devez fournir :",
          billNumberDesc: "Le numéro unique attribué à votre facture.",
          payerNameDesc: "Inscrivez le prénom et le nom exactement tels qu'ils apparaissent dans la section « Facturé à » de votre facture.",
          amountDesc: "Le montant total dû, taxes incluses.",
          tipTitle: "Conseil",
          tipDesc: "Les trois champs doivent être complétés. Les informations saisies doivent correspondre exactement à celles figurant sur votre facture pour permettre sa recherche."
        },
        invoiceFound: {
          matchMessage: "Une facture correspondant aux informations saisies a été trouvée.",
          verifyMessage: "Veuillez vérifier les renseignements ci-dessous avant de procéder au paiement."
        },
        summary: {
          title: "Résumé de la facture",
          subtotal: "Sous-total",
          tps: "TPS",
          tvq: "TVQ",
          totalDue: "Total à payer"
        },
        securePayment: {
          title: "Paiement sécurisé",
          message: "Les informations de paiement sont transmises de façon sécurisée selon les normes de l'industrie.",
          noCardStorage: "Aucune information de carte de crédit n'est conservée par l'Ordre des dentistes du Québec."
        },
        paymentInfo: {
          title: "Informations de paiement",
          cardholderName: "Nom du titulaire de la carte",
          cardholderNamePlaceholder: "Nom du titulaire",
          cardholderNameHint: "Entrez le nom exactement tel qu'il apparaît sur votre carte.",
          importantTitle: "Important",
          importantMessage: "Les trois champs sont obligatoires et doivent correspondre exactement aux informations figurant sur votre carte.",
          invoiceVerified: "J'ai vérifié les informations de la facture.",
          chargeAuthorized: "J'autorise le prélèvement du montant indiqué ci-dessus.",
          pay: "Payer {{amount}}",
          back: "Retour"
        },
        confirmation: {
          title: "Paiement effectué avec succès",
          processed: "Votre paiement a été traité avec succès.",
          invoicePaid: "Votre facture est maintenant acquittée.",
          amountPaid: "Montant payé",
          invoiceCard: {
            title: "Facture payée",
            number: "Numéro de facture",
            date: "Date de facturation",
            description: "Description"
          },
          receiptCard: {
            title: "Reçu de transaction Moneris",
            transactionId: "Identifiant de transaction",
            dateTime: "Date et heure de transaction",
            cardType: "Type de carte",
            cardNumber: "Numéro de carte",
            authorization: "Numéro d'autorisation"
          },
          checks: {
            invoicePaid: "Facture acquittée",
            authorized: "Transaction autorisée par l'institution financière",
            authorizedShort: "Transaction autorisée",
            noAction: "Aucune autre action n'est requise"
          },
          thankYou: "Merci. Veuillez conserver ces informations pour vos dossiers.",
          actions: {
            anotherPayment: "Effectuer un autre paiement",
            home: "Retour à l'accueil",
            print: "Imprimer le reçu"
          }
        }
      }
    },
    individual: {
      title: "Individu",
      fields: {
        firstname: "Prénom",
        lastname: "Nom de famille",
      },
    },
    profile: {
      language: "FR",
      welcome: "Bienvenue",
      settings: "Paramètres",
      disable_notifications: "Désactiver les notifications",
      sign_in: "Se connecter",
      sign_out: "Déconnexion",
      resetPassword: "Mot de passe oublié",
      sessionExpiring: {
        line1: "Votre session expire dans {{timeLeft}} minutes.",
        line2:
          "Terminez votre travail avant ce délai. Cliquer 'Renouveler session' pour continuer à travailler.",
      },
      renew: "Renouveler session",
    },
    version: {
      labelBeforeAnchor:
        "Une nouvelle version du site web est maintenant disponible, no {{latestVersion}}. Cliquez ",
      labelAnchor: "ici",
      labelAfterAnchor: " pour actualiser la page.",
    },
    mailbox: {
      title: "Vous avez {{count}} nouveau message",
    },
    messages: {
      menuTitle: "Messages sécurisés",
    },
    secureMessages: {
      title: "Messages sécurisés",
      intro:
        "Consultez ici les messages sécurisés qui vous sont adressés. Ces messages peuvent contenir des informations importantes concernant vos réclamations, votre couverture ou toute autre communication confidentielle.",
      comingSoon: "À venir",
      groups: {
        insuranceFund:
          "Fonds d'assurance responsabilité professionnelle de l'Ordre des dentistes du Québec",
        orderOfDentists: "Ordre des dentistes",
      },
      categories: {
        claims: "Réclamations",
        communication: "Communication",
        admission: "Admission / Tableau",
        practiceInCompany: "Exercice en société",
        inspection: "Inspection professionnelle",
        syndic: "Syndic",
        continuingEducation: "Formation continue",
        other: "Autres communications",
      },
    },
    company: {
      selectActiveCompany: "Sélectionnez votre société active",
      fields: {
        id: "Identifiant",
        name: "Nom",
      },
      formState: {
        noForm: "Cette société n'a aucun formulaire disponible",
        modify: "Modifier",
        viewSummary: "Voir sommaire",
        status: {
          Initial: "Non commencé",
          InProgress: "En cours",
          Completed: "Complétée",
          undefined:
            "Initialisation du formulaire en cours - veuillez patienter",
          Payed: "Payé",
        },
      },
    },
    shoppingCart: {
      title: "Panier d'achat",
      empty: "Votre panier est vide",
      cartItem: {
        title: "Titre",
        description: "Description",
        quantity: "Quantité",
        total: "Total",
      },
      payment: {
        creditCardNumber: "Numéro de carte de crédit",
        expirationDate: "Date d'expiration (MMAA)",
        proceedWithPayment: "Soumettre le paiement",
        modern: {
          frameTitle: "Informations de la carte de crédit",
          cardNumber: "Numéro de carte *",
          expirationDate: "Date d'expiration (MM/AA) *",
          securityCode: "Code de sécurité (CVC) *",
          cardNumberShort: "Numéro de carte :",
          cardNumberHint: "Saisissez le numéro de votre carte Visa ou Mastercard.",
          expirationDateShort: "Date d'expiration :",
          expirationDateHint: "Entrez la date d'expiration figurant sur votre carte.",
          securityCodeShort: "Code de sécurité :",
          securityCodeHint: "Code à 3 chiffres figurant au verso de votre carte."
        },
        error: {
          title: "Erreur de paiement",
          code: "Code d'erreur",
          unProcessedPayment: "Le paiement n'a pas été effectué.",
          priceChange: "Les frais de votre déclaration ont changé et ont été mis à jour pour refléter le nouveau coût. Veuillez réessayer le paiement.",
          940: "Id de profil invalide (sur la requête de tokenisation)",
          941: "Erreur lors de la génération du token",
          942: "Id de profil invalide, ou d'URL source",
          943: "Numéro de carte invalide (non numérique)",
          944: "Date d'expiration invalide (mmaa, doit être le mois courant ou dans le futur)",
          945: "Code CVD invalide (3-4 chiffres)",
          51: "Transaction refusée",
        },
      },
      checkout: {
        warning: `<ul class='mt-4'>
        <li><p><span class='font-weight-bold'>Avant de passer au paiement, veuillez vérifier le sommaire et vous assurer que les renseignements fournis sont exacts, car il ne sera plus possible d'apporter des changements lorsque le paiement aura été fait.</span></p></li>
        <li><P>Le paiement de frais exigibles s’effectue <span  class='font-weight-bold'>EXCLUSIVEMENT EN LIGNE</span>
          au moyen d’une carte de crédit Visa ou MasterCard.</P></li>
            <li><P>Les frais exigibles sont : </P>
              <ul>
                <li class='font-weight-bold'>330.00$ par société N’EXPLOITANT <span class='text-danger'>AUCUN</span> établissement ou EXPLOITANT <span class='text-danger'>UN SEUL</span> établissement;</li>
                <li class='font-weight-bold'>330.00$ pour chaque établissement supplémentaire <span class='text-danger'>EXPLOITÉ</span> par la société.</li>
              </ul>
            </li>
          </ul>`,
        title: "Paiement",
        amountToPay:
          "La somme de {{amount}}$ sera imputée au compte de la carte de crédit.",
        studentAmountToPay:
          "Le système a identifié une facture correspondant aux informations saisies. Veuillez renseigner vos informations de paiement. Un montant de {{amount}}$ sera débité de votre carte afin de finaliser le paiement de la facture",
        transactionDetails: {
          title: "Détails de la transaction",
          item: "{{title}} , {{price}}$ chacun",
        },
      },
      receipt: {
        pdfGenerating:
          "Veuillez patienter pendant que nous générons la version finale de votre sommaire",
        title: "Reçu",
        subject:
          "Nous avons bien reçu votre paiement pour la {{payment_b}} {{payment_a}}",
        amountCC:
          "La somme de <span class='font-weight-bolder'>{{amount}}$</span> sera imputée au compte de la carte de crédit {{cc}}",
        invoice: "Facture",
        transactionReference: "Référence de transaction en ligne",
        repondant: "Répondant",
        societe: "Société",
        fileNumber: "Numéro de dossier",
        reference: {
          transactionType: "Type de transaction",
          orderId: "No de commande",
          dateTime: "Date et heure",
          sequenceNumber: "Numéro de séquence",
          message: "Message",
          amount: "Montant",
          approvalCode: "Code d'approbation",
          responseCode: "Code Réponse/ISO",
        },
        refundPolicy: {
          title: "Politique de remboursement",
          detail: "Aucun remboursement.",
        },
        ODQAddress: {
          odq: "Ordre des dentistes du Québec (ODQ)",
          line1: "800 René-Lévesque Ouest, suite 1640",
          line2: "Montréal (Québec) H3B 1X9",
        },
      },
      nextStep: "Prochaine étape",
      pleaseWaitPayment:
        "Nous vous prions de bien vouloir patienter pendant le traitement de la transaction et de ne pas quitter la page avant d’avoir reçu la confirmation",
    },
    memberCard: {
      title: "Carte de membre",
    },
    studentCard: {
      title: "Carte de membre étudiant",
    },
    addresses: {
      title: "Gestion des adresses",
    },
    inscription: {
      title: "Inscription",
      yearSelection: {
        formForYear: "Formulaire pour l'année",
        fillForm: "Remplir le formulaire",
        downloadForm: "Télécharger le formulaire",
        formSubmitted: "Votre formulaire a été soumis.",
        pdfNotAvailable:
          "Votre récapitulatif PDF sera disponible au prochain jour ouvrable",
        notOpenedYet: "Le formulaire n'est pas encore ouvert.",
        noFormAccess: "L'accès au formulaire est désactivé.",
        showForm: "Afficher le formulaire",
      },
    },
    bills: {
      title: "Reçus",
    },
    invoices: {
      title: "Factures",
    },
    billsAndInvoices: {
      title: "Reçus/Factures",
    },
    farpSubscription: {
      title: "Souscription FARPODQ",
    },
    professionalServices: {
      title: "Inspection professionnelle",
      links: {
        surveysToComplete: "Questionnaire(s) à saisir",
        surveysHistory: "Historique des questionnaires",
        documentsToShare: "Partage de documents",
      },
    },
    generalPublic: {
      title: "Grand public",
      titleSharedProjects: "Projets partagés",
      sharedProjects: {
        description: "Description",
        startDate: "Date de début",
        endDate: "Date de fin",
        name: "Nom du projet",
      }
    },
    dentalAssistant: {
      title: "Assistant(e) Dentaire",
      links: {
        surveysToComplete: "Questionnaire(s) à saisir",
        surveysHistory: "Historique des questionnaires",
        inscription: "Inscription/Renouvellement",
        documentsToShare: "Partage de documents",
        card: "Carte d'assistant(e) dentaire",
      },
      invoicesReceipts: "Factures / reçus",
    },
    formation: {
      action: {
        addActivity: "Déclarer une nouvelle activité",
        refreshList: "Rafraîchir la liste",
        updateActivityInformation: "Corriger les informations de l’activité",
        updateActivityDeclaredUFC: {
          title: "Modifier le nombre déclaré d’UFC",
          message: "Nombre d’UFC modifié avec succès",
        },
        updateActivityApprovedUFC: "Corriger le nombre d’UFC reconnues",
        removeActivity: "Retirer l’activité",
        removeActivityToaster: {
          title: "Activité retirée",
          message: "L’activité a été retirée avec succès.",
        },
        removeDocument: "Retirer l'attestation",
        addDocument: "Ajouter une attestation",
        addActivityDocument: {
          title: "Ajouter une attestation",
          message: "L’attestation a été ajoutée avec succès.",
        },
        removeActivityDocument: {
          title: "Retirer l'attestation",
          message: "L’attestation a été retirée avec succès.",
        },
      },
      title: "Formation continue",
      trainingRecord: "Registre de formation",
      exemptions: "Dispenses",
      continuingEducation: "Votre registre de formation continue",
      referencePeriod: "Période de référence",
      noReferencePeriods: "Aucune periode de réference disponible",
      exportPdf: "Exporter la période",
      dialog: {
        add: "Ajouter",
        update: "Modifier",
        confirmRemoval: "Voulez-vous vraiment retirer cette activité?",
        addActivity: {
          referenceYear: "Année de référence",
          date: "Date de l’activité ou de la complétion de l’activité",
          category: "Type d'activité",
          establishment: "Organisme / établissement",
          establishmentName: "Nom de l’organisme / établissement",
          etsActivitiesLabel: "Activités dispensées par cet organisme le",
          otherNotInList: "Autre activité qui n’est pas dans la liste",
          establishmentHelpMessage:
            "Saisissez les premières lettres du nom de l’organisme ou de l’établissement, puis sélectionnez parmi les Organismes/Établissements dans la liste à l’aide du menu déroulant.",
          addEstablishmentHelpMessage: `Pour ajouter un Organisme/Établissement qui ne figure pas dans la liste, cliquez sur « Autre établissement » à la fin de celle-ci.`,
          dentoformNotice:
            "À compter du 1er octobre 2024, les formations suivies sur Dentoform seront automatiquement enregistrées dans votre registre. Les formations effectuées avant cette date devront être ajoutées manuellement.",
          jdiqCenterNotice: 'À compter du 29 mai 2025, les formations suivies au cours des journées dentaires internationales du Québec (JDIQ) seront automatiquement enregistrées dans votre registre. Les formations effectuées avant cette date devront être ajoutées manuellement.',
          odqCenterNotice: 'Les formations Dentoform de l’Ordre des dentistes sont automatiquement déclarées dans le registre. Pour déclarer une activité des Journées dentaires internationales du Québec, sélectionnez-la dans la liste déroulante.',
          uploadFileTitle: "Téléverser l'attestation",
          uploadFileMessage:
            "Le fichier ne sera téléversé qu’après avoir cliqué sur le bouton «Sauvegarder».",
          uploadFile: "Téléverser un fichier",
          depositFile: "Déposez un fichier",
          activity: {
            adaCerpFlag: "Reconnu ADA-CERP",
            title: "Titre de l'activité",
            subject: "Discipline, domaine, sujet ou titre",
            description: "Description / informations complémentaires",
            date: "Date",
            dateOfCompletion: "Date de la complétion de l’activité",
            theoreticalDuration: "Durée en heures",
            practicalDuration: "Nombre d’heures atelier pratique",
            trainingDuration: "Nombre d’heures d’enseignement",
            startAt: "Début",
            endAt: "Fin",
            duration: "Durée en heures",
            sessionType: "Type de séance",
            declaredUfcPoints: "Nombre d’unités déclarées",
            ufcPoints: "Nombre d’unités",
          },
          OTHER: "Autre établissement",
          toaster: {
            title: "Activité ajoutée",
            message: "L’activité a été ajoutée.",
          },
        },
        addDocument: {
          title: "Ajouter une attestation",
          uploadDocument: "Téléverser l'attestation",
          cancel: "Annuler",
        },
        updateDeclaredUfc: {
          oldValue: "Ancienne valeur",
          newValue: "Nouvelle valeur",
        },
      },
      sessionType: {
        Theoretical: "Conférence",
        Practical: "Pratique",
        Discussion: "Discussion",
      },
      stats: {
        ufcPerYearTitle: "Minimum d’UFC par année",
        ufcPerPeriodTitle: "UFC par période de référence",
        ufcOrgsRecognized: "Organismes reconnus",
        ufcOrgsNotRecognized: "Autres organismes",
        ufcNotCounted: "UFC excédentaires",
        ufcOrgsRecognizedTodDo: "UFC org. reconnus à faire",
        ufcOrgsNotRecognizedTodDo: "UFC autres org. à faire",
        recognizedRequired: "UFC exigés auprès des organismes et établissements reconnus",
        totalRequired: "Total UFC exigés pour des activités qui répondent le mieux à vos besoins et qui sont en lien avec l’exercice de la profession",
        ufcThreePoints: "UFC spécifiques par période de référence",
      },
      list: {
        date: "Date",
        activityName: "Titre de l’activité",
        activityCategory: "Type d’activité",
        establishment: "Organisme / établissement",
        odqApproved: "Organisme / établissement reconnu ODQ",
        odqApprovedFlag: {
          NA: "Non disponible",
          Recognized: "Reconnu",
          NotRecognized: "Non reconnu",
        },
        declaredUFCpoints: "UFC déclarées",
        approvedUFCpoints: "UFC organismes reconnus",
        notRecognizedUFCpoints: "UFC autres organismes",
        UFCRefusalExplanation: "Explication du refus de reconnaissance des UFC",
        action: "Action",
        noData: "Pas de donnée",
        from: "De",
        to: "à",
        hours: "Horaire",
        downloadDocument: "Télécharger l'attestation",
      },
      noDataError: {
        title: "Aucune donnée disponible",
        message:
          "Aucune donnée associée à votre compte, veuillez contacter l’administrateur.",
      },
    },
    address: {
      search: {
        label: "Adresse",
        placeholder: "Commencez à taper votre adresse...",
      },
      line1: "Adresse ligne 1",
      line2: "Adresse ligne 2",
      buildingNumber: "N°",
      street: "Rue",
      city: "Municipalité / Ville",
      province: "Province / État",
      postalCode: "Code postal",
      country: "Pays",
      noMatch: "Pas de correspondance? Entrer l'adresse manuellement.",
      searchError:
        "Nous ne sommes pas parvenus à contacter Postes Canada pour le moment. Veuillez entrer l'adresse manuellement ou réessayer plus tard. Contactez le support si le problème persiste.",
    },
    forgetPassword: {
      title: "Récupération du code d'identification",
      firstStep: "Entrer les informations requises",
      secondStep: "Valider les informations",
      permitNumber: "Numéro de permis",
      birthDate: "Date de naissance",
      day: "Jour",
      month: "Mois",
      year: "Année",
      email: "Veuillez confimer l'adresse de courriel",
      next: "Suivant",
      previous: "Précédent",
      done: "Complété",
      step1Error:
        "Les informations entrées ne correspondent pas à celles apparaissant à votre dossier",
      step2Error:
        "L'adresse courriel entrée ne correspond pas à celle apparaissant à votre dossier",
      invalidEmail:
        "L'adresse de courriel entrée ne correspond pas à celle dans le système",
      invalidDay: "Le jour doit être compris entre 1 et 31",
      invalidMonth: "Le mois doit être compris entre 1 et 12",
      invalidYear: "L'année doit être supérieure à 1800",
      invalidBirthDate: "La date de naissance est invalide",
      emailConfirmation:
        "Le code d'identification a été transmis à l'adresse courriel indiquée",
      closePage: "Fermer la page",
    },
    footer: {
      copyright:
        "© Tous droits réservés {{year}} - Ordre des dentistes du Québec",
      links: {
        contactUs: "Contact",
        confidentialityAgreement: "Confidentialité",
        termsOfUse: "Conditions",
      },
    },
    legalEntity: {
      title: "Exercer en société",
      fillForm: "Veuillez remplir le formulaire en cliquant ici",
      buttonTitle: "Exercer en société - ",
      buttonTitlePeriod: "Déclaration annuelle 2026",
    },
  },
};
